
import Vue from 'vue';
import Component from 'vue-class-component';
import { Watch, Prop } from 'vue-property-decorator';
import { ProductKeyQuantity } from 'Api/DynamicwebApi';
import cart from 'Store/cart/cart';
import PorterBudgetStore from 'Store/porterBudget/porterBudget';
import ABaseComponent from 'Components/Base/ABaseComponent';
import { AddToBasketState } from 'Components/Ecom/AddToBasketField/AddToBasketFieldComponent';
import { IPorterBudget, IPorter } from 'Api/CoreApi';
//import UserInformationComponent from "Components/Base/UserInformationComponent";
import { EventBus, EventBusEvents } from "Components/Base/EventBus";

const namespace: string = 'cart';


@Component({
    template: '#add-to-basket-porter-field-template'
})
export default class AddToBasketPorterFieldComponent extends ABaseComponent {

    // Properties
    @Prop()
    productId: string;
    @Prop()
    variantId: string;
    @Prop()
    unitOfMeasure: string;
    @Prop({ default: "LANG1" })
    languageId: string;
    @Prop()
    extraFields: { [key: string]: any };
    @Prop()
    isDisabled: boolean;
    @Prop()
    price: number;

    get currentIsDisabled() {
        // TEST
        if (this.isDisabled) return true;
        if (this.currentBudget) {
            if (this.currentBudget.budgetAmountRemaining <= 0 && this.porter.hasBudget)
                return true;

            if (this.currentBudget.budgetAmountRemaining < this.price)
                return true;

            return false;
        } else {
            return true;
        }
    }

    get budget() {
        return PorterBudgetStore.state.porterBudget;

    }
    get porter() {
        return PorterBudgetStore.state.porter;
    }

    get isLoading() {
        return this.state === AddToBasketState.Adding;
    }


    async created() {
        //this.porter = await UserInformationComponent.getPorter();
        //await porterBudgetStore.dispatchFetchPorterBudget();
    }


    state: AddToBasketState = AddToBasketState.None;
    error: string = '';

    internalQuantity: number = 0;

    get cart() {
        return cart.state;
    }

    get variantFieldId(): string {
        return this.productId + "_" + this.variantId
    }

    get quantity(): number {
        return this.internalQuantity;
    }

    async addToCart() {
        this.quantity = this.quantity + 1;

        //const postModel = {
        //    CartCmd: "Add",
        //    ProductID: this.productId,
        //    VariantID: this.variantId
        //};
        //$.post("/", postModel);
    }

    set quantity(val: number) {

        if (this.extraFields === undefined) {
            this.extraFields = { PorterName: this.porter.firstName + ' ' + this.porter.lastName, PorterId: this.porter.id, ContactNo: this.porter.contactNo, PorterEmployeeCode: this.porter.genericFields.EmployeeCode };
        }

        this.internalQuantity = val;
        this.setLoading();
        this.state = AddToBasketState.Adding;

        cart.dispatchUpdateCart(new ProductKeyQuantity({
            productId: this.productId,
            variantId: (this.variantId) ? `Size_${this.variantId}` : "",
            unitOfMeasure: this.unitOfMeasure,
            extraKeys: this.extraFields,
            quantity: this.quantity,
            languageId: this.languageId
        })).then(async () => {
            await PorterBudgetStore.dispatchFetchPorterBudget();
            //await UserInformationComponent.refreshBudget();

            //EventBus.$emit(EventBusEvents.EventBusRefreshBudgetEventName);

            this.state = AddToBasketState.Added;
            this.setLoaded();
        })
            .catch(e => {
                this.state = AddToBasketState.Error;
                this.setError(e);
            });
    }

    @Watch('unitOfMeasure')
    public unitOfMeasureChanged() {
        this.load();
    }

    get currentBudget(): IPorterBudget {
        return PorterBudgetStore.state.porterBudget;
    }

    mounted() {
        this.load();
    }

    load() {
        this.internalQuantity = 0;
        this.state = AddToBasketState.None;
        this.error = '';
        cart.dispatchFetchCart().then(
            () => {
                if (cart.state.summary && this.state !== AddToBasketState.Adding) {
                    for (let line of cart.state.summary.lines) {
                        if (line.productId !== this.productId) continue;
                        if (line.variantId !== "Size_" + this.variantId) continue;
                        if (line.unitOfMeasure !== this.unitOfMeasure) continue;

                        let differenceInExtraFields = false;
                        for (let key in this.extraFields) {
                            if (line.extraKeys[key] !== this.extraFields[key]) {
                                differenceInExtraFields = true;
                            }
                        }
                        if (differenceInExtraFields) continue;

                        this.internalQuantity = line.quantity;
                        return;
                    }
                }
            }
        );

    }
}

Vue.component('add-to-basket-porter-field', AddToBasketPorterFieldComponent);
